import { ISelectOption } from 'shared/components/ui/Select/Select';
import { useAccount, useSwitchChain } from 'shared/hooks/use-web3';
import { useGamesStore } from 'shared/store/games-store';
import { useRoomStore } from 'shared/store/roomStore';

export const useSwitchChainHandler = () => {
  const { switchChainAsync } = useSwitchChain();
  const { address } = useAccount();
  const { resetRoom } = useRoomStore();
  const { clearStore } = useGamesStore();
  return async (option: ISelectOption) => {
    clearStore();
    try {
      await switchChainAsync({ chainId: option.value as number });
    } catch (error) {
      console.error('Error switching chain:', error);
    } finally {
      resetRoom(address?.toLowerCase() as `0x${string}`);
    }
  };
};
